import React from "react";

function SummaryCount({schoolAssignedCardsCount, studentsNumber, schoolContacts, schoolAssignedWristbandsCount}) {

    return (
        <div class="col-8-xxxl col-lg-8 col-12">
            <div class="row">

                <div class="col-lg-6">
                    <div class="dashboard-summery-one mg-b-20 gradient-my-blue">
                        <div class="row align-items-center">
                            <div class="col-6">
                                <div class="item-icon bg-light">
                                    <img alt="avatar" src={process.env.PUBLIC_URL + "/assets/img/figure/students.png"}/>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="item-content">
                                    <div class="item-title" style={{ color: "white" }}>
                                        Students
                                    </div>
                                    <div class="item-number" style={{ color: "white" }}>
                                        <span class="counter">
                                            {studentsNumber ? studentsNumber.total_p : "..."}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="dashboard-summery-one mg-b-20 gradient-my-blue">
                        <div class="row align-items-center">
                            <div class="col-6">
                                <div class="item-icon bg-light">
                                    <img alt="avatar" style={{height:"60px"}} src={process.env.PUBLIC_URL + "/assets/img/figure/phone-call.png"}/>

                                </div>
                            </div>
                            <div class="col-6">
                                <div class="item-content">
                                    <div class="item-title" style={{ color: "white" }}>
                                        Contacts
                                    </div>
                                    <div class="item-number" style={{ color: "white" }}>
                                        <span class="counter">
                                            {schoolContacts ? schoolContacts.total_c: "..."}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-6">
                    <div class="dashboard-summery-one mg-b-20 gradient-my-blue">
                        <div class="row align-items-center">
                            <div class="col-6">
                                <div class="item-icon bg-light">
                                    <img alt="avatar" style={{height:"60px"}} src={process.env.PUBLIC_URL + "/assets/img/figure/id-card.png"}/>

                                </div>
                            </div>
                            <div class="col-6">
                                <div class="item-content">
                                    <div class="item-title" style={{ color: "white" }}>
                                        Assigned Cards
                                    </div>
                                    <div class="item-number" style={{ color: "white" }}>
                                        <span class="counter">
                                            {schoolAssignedCardsCount ? schoolAssignedCardsCount.total_p: "..."}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            
                <div class="col-lg-6">
                    <div class="dashboard-summery-one mg-b-20 gradient-my-blue">
                        <div class="row align-items-center">
                            <div class="col-5">
                                <div class="item-icon bg-light">
                                    <img alt="avatar" style={{height:"60px"}} src={process.env.PUBLIC_URL + "/assets/img/figure/smart.png"}/>

                                </div>
                            </div>
                            <div class="col-7">
                                <div class="item-content">
                                    <div class="item-title" style={{ color: "white" }}>
                                        Assigned Wristbands
                                    </div>
                                    <div class="item-number" style={{ color: "white" }}>
                                        <span class="counter">
                                            {schoolAssignedWristbandsCount ? schoolAssignedWristbandsCount.total_p: "..."}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    );
}

export default SummaryCount;
